import React from 'react';
import { Button, Tooltip } from 'antd';
import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { getSourceString } from '../../../../../helpers/StringHelper';
import { EyeOutlined } from '@ant-design/icons';
import moment from 'moment';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const ViewStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  .ghosted {
    border: 0px;

    span {
      text-decoration: underline;
    }
  }
`;



export const linkingColumns = (t) => [
  {
    title: t('Type of Subject'),
    dataIndex: 'type',
    key: 'type',
    show: true,
    project: true,
    search: true,
    render: type => t(type),
    searchType: 'dropdown',
  },
  {
    title: t('System ID'),
    dataIndex: 'datastakeId',
    key: 'datastakeId',
    show: true,
    project: true,
    sorter: (a, b) => ('' + a.id).localeCompare(b.id),
    render: (id, item) => {
      let link = '';
      switch (item.type) {
        case 'stakeholder':
          link = `/app/pme/stakeholders/${id}`;
          break;
        case 'event':
          link = `/app/pme/events/${id}`;
          break;
        case 'location':
          link = `/app/pme/locations/${id}`;
          break;
        case 'lir':
          link = `/app/pme/lir/${id}`;
          break;
        default:
          link = '#';
          break;
      }
      return <NavLink className="projectLink" to={link}>
        {id}
      </NavLink>
    },
    search: true,
  },
  {
    title: t('Name'),
    dataIndex: 'name',
    key: 'name',
    show: true,
    project: true,
    render: (name) => name,
    search: true,
  },
  {
    title: t('Connected as'),
    dataIndex: 'usedAs',
    key: 'usedAs',
    show: true,
    project: true,
    render: (used) => {
      const language = localStorage.getItem('datastakeLng') || 'en';
      return used[language];
    },
    search: true,
  },
];
const columns = (t, filterBy = 'show', sourceId = 'overview', activeFilters = {}) => {
  const cols = [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'datastakeId',
      show: true,
      project: true,
      overview: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'datastakeId' ? activeFilters.sortDir : undefined,
      render: (id, item) => {
        const editView = 'scl';
        const pathname = (item.children)
          ? `/app/pme/analysis/${editView}/${item.id}`
          : `/app/pme/analysis/${editView}/${item.id}/${item.authorId}`;
        // item.isChild && `/app/${module}/analysis/${editView}/${item.id}?defaultSources=${item.authorId}`
        
        return (
          sourceId === 'overview' && item.children ? id : <NavLink className="projectLink" to={pathname}>
            {id}
          </NavLink>
        )
      },
      search: true,
    },
    {
      title: t('Name'),
      dataIndex: 'locationName',
      key: 'locationName',
      overview: true,
      defaultSortOrder: activeFilters.sortBy === 'locationName' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      show: true,
      project: true,
      primarySearch: true,
    },
    // {
    //   title: t('Type'),
    //   dataIndex: 'locationType',
    //   key: 'category',
    //   overview: true,
    //   show: true,
    //   project: true,
    //   search: true,
    //   searchType: 'dropdown',
    // },
    {
      title: t('Sources'),
      dataIndex: 'sourcesLen',
      key: 'sourcesLen',
      overview: true,
      search: true,
    },
    {
      title: t('Province'),
      dataIndex: 'province',
      key: 'province',
      show: true,
      project: true,
      search: true,
    },
    {
      title: t('Territory'),
      dataIndex: 'territory',
      key: 'territory',
      show: true,
      project: true,
      search: true,
    },
    {
      title: t('Products'),
      dataIndex: 'mineralTitleScope',
      key: 'mineralTitleScope',
      // sorter: (a, b) => {
      //   if (a.nrOfWorkers === '-' || !a.nrOfWorkers) {
      //     a.nrOfWorkers = '0';
      //   }
      //   if (b.nrOfWorkers === '-' || !b.nrOfWorkers) {
      //     b.nrOfWorkers = '0';
      //   }
      //   return parseInt(a.nrOfWorkers) > parseInt(b.nrOfWorkers)
      // },
      render: (v) => (v || '').length ? v : '-',
      show: true,
      project: true,
    },
    {
      title: t('Operator'),
      dataIndex: 'operator',
      key: 'operator',
      show: true,
      project: true,
    },
    {
      title: t('Author'),
      dataIndex: 'author',
      key: 'author',
      show: false,
      project: true,
      search: true,
      publication: true,
      render: (author, item) => {
        return getSourceString(author, item);
      }
    },
    {
      title: t('Last Update'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      show: true,
      project: true,
      search: false,
      publication: true,
      ellipsis: true,
      render: (updatedAt, item) => {
        const date = item.publishedAt || updatedAt;
        const title = date ? moment(date).format('DD MMM YYYY') : '';
        return <Tooltip title={title}>{title}</Tooltip>
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      show: false,
      project: true,
      publication: true,
      render: (_, item) => {
        const editView = 'scl';

        const pathname = (item.children)
          ? `/app/pme/analysis/${editView}/${item.id}`
          : `/app/pme/analysis/${editView}/${item.id}/${item.authorId}`;
        // item.isChild && `/app/${module}/analysis/${editView}/${item.id}?defaultSources=${item.authorId}`
        return (
          <ViewStyle className="view-btn-scl-table">
            <Link to={pathname}>
              <Button
                className={formatClassname([
                  item.children ? 'primary' : 'ghosted',
                  'no-ln-height',
                ])}
                type={item.children ? 'primary' : 'ghost'}
                icon={<EyeOutlined />}
              >
                {t('View')}
              </Button>
            </Link>
          </ViewStyle>
        )
      }
    }
    // {
    //   title: t('Status'),
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: status => {
    //     const defaultStatus = { value: '--', label: '--', color: 'default' };
    //     const allStatuses = [
    //       { label: t('Identified'), value: 'Identified', color: 'default' },
    //       { label: t('In Progress'), value: 'In Progress', color: 'warning', },
    //       { label: t('Assessed'), value: 'Assessed', color: 'blue' },
    //       { label: t('Connected'), value: 'Connected', color: 'success' },
    //     ];
    //     const statusOptions = allStatuses.find(s => s.value === status) || defaultStatus;
    //     return (
    //       <Tag key={status.value} color={status.color || 'default'} >{status.label}</Tag>
    //     )
    //   }
    // },
  ]
  return cols.filter(col => col[filterBy]);
};
export default columns;
